import { render, staticRenderFns } from "./Witure.vue?vue&type=template&id=5fd34770&"
import script from "./Witure.vue?vue&type=script&lang=js&"
export * from "./Witure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports